var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MModal',{attrs:{"visible":_vm.visible,"title":_vm.$t(`Common.title.payCost`),"zIndex":999,"wrapClassName":"pdf__view","okText":_vm.$t('Common.action.confirm'),"cancelText":_vm.$t('Common.action.cancel')},on:{"change":_vm.onVisibleChange,"ok":_vm.onConfirm}},[_c('m-form',{ref:"form"},[_c('m-input',{attrs:{"is-form-item":"","label":this.$t(`apply.title.userName`),"rules":[
      {
        required: true,
        message: this.$t(`Common.message.pleaseEnter`),
      },
    ]},model:{value:(_vm.form.clientName),callback:function ($$v) {_vm.$set(_vm.form, "clientName", $$v)},expression:"form.clientName"}}),_c('m-input',{attrs:{"is-form-item":"","label":this.$t('apply.title.email'),"rules":[
      {
        pattern: _vm.emailNum,
        message: this.$t('Common.message.formatError'),
      },
    ]},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_c('m-input',{attrs:{"is-form-item":"","label":this.$t('apply.title.confirmEmail'),"rules":[
      {
        pattern: _vm.emailNum,
        message: this.$t('Common.message.formatError'),
      },
    ]},model:{value:(_vm.form.confirmEmail),callback:function ($$v) {_vm.$set(_vm.form, "confirmEmail", $$v)},expression:"form.confirmEmail"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }